import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const batchOverviewStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            padding: "10px 50px 30px 50px",
        },
        smallIndicator: {
            width: "45px",
            marginLeft: "10px",
        },

        divider: {
            margin: "10px 0px 10px 0px",
        },
        gridTitle: {
            color: "#525252",
            letterSpacing: "0.07em",
            textTransform: "uppercase",
            lineHeight: "120%",
        },
        text: {
            color: "#181818",
            fontWeight: 500,
        },
        grid: {
            marginTop: "10px",
            padding: "20px",
        },
        highlightedText: {
            color: "#270ADC",
            cursor: "pointer",
        },
        iconSpacing: {
            marginRight: "10px",
        },

        selectContainer: {
            display: "flex",
            alignItems: "center",
            marginTop: "20px",
        },

        productFlowSelect: {
            width: "300px",
            marginLeft: "10px",
        },
    })
);
